import { UIGameMapEdgeController } from './UIGameMapEdgeController.ts';
import { UIGameMapView } from './UIGameMapView.ts';
import { UIGameGeneralTileController } from './UIGameGeneralTileController.ts';
import { UIGameMapPortController } from './ui_game_map_port/UIGameMapPortController.ts';
import { UIGameMapCornerController } from './UIGameMapCornerController.ts';
import { UIGameMapViewBoundaries } from './UIGameMapViewBoundaries.ts';
import { UIGameMapHoverController } from './ui_game_map_hover/UIGameMapHoverController.ts';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { UIGameMapTileCenterHighlightController } from './ui_game_map_highlight/UIGameMapTileCenterHighlightController.ts';
import { UIGameMapTileEdgeHighlightController } from './ui_game_map_highlight/UIGameMapTileEdgeHighlightController.ts';
import { UIGameMapTileCornerHighlightController } from './ui_game_map_highlight/UIGameMapTileCornerHighlightController.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { getGameWorldZoomClampMultiplier } from '@colonist/ui-game';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
export class UIGameMapController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.CanvasResized:
                this.resizeMapView();
                break;
            default:
                break;
        }
    }
    getFitScale() {
        const zoomClampMultiplier = getGameWorldZoomClampMultiplier(UIUtilsEjsVariables.isUserOnMobileAppOrWeb, UIUtilsEjsVariables.shouldDisplayNewMobileGameUI);
        const widthFit = this.mapView.screenWidth / this.mapView.worldWidth * zoomClampMultiplier;
        const heightFit = this.mapView.screenHeight / this.mapView.worldHeight * zoomClampMultiplier;
        return Math.min(widthFit, heightFit);
    }
    initializeMapView() {
        const canvas = this.uiGameManager.canvasController;
        const width = canvas.appW - canvas.chatWidth;
        const height = canvas.appH - canvas.itemSize;
        return new UIGameMapView(0, 0, width, height, canvas.app);
    }
    resizeMapView() {
        var _this_onMapResized, _this;
        const canvas = this.uiGameManager.canvasController;
        const width = canvas.appW - canvas.chatWidth;
        const height = canvas.appH - canvas.itemSize;
        this.mapView.resize(width, height);
        const didCanvasWidthChange = canvas.appW != this.lastCanvasWidth;
        this.lastCanvasWidth = canvas.appW;
        if (!this.mapBuilt) return;
        (_this_onMapResized = (_this = this).onMapResized) === null || _this_onMapResized === void 0 ? void 0 : _this_onMapResized.call(_this, didCanvasWidthChange);
    }
    setInteractionEnabled(enabled) {
        if (enabled) this.mapView.enableInteraction();
        else this.mapView.disableInteraction();
    }
    createMap() {
        new UIGameMapViewBoundaries(this.uiGameManager);
        new UIGameGeneralTileController(this.uiGameManager);
        this.portController = new UIGameMapPortController(this.uiGameManager);
        this.cornerController = new UIGameMapCornerController(this.uiGameManager);
        new UIGameMapEdgeController(this.uiGameManager);
        this.mapView.sortChildren();
        this.mapBuilt = true;
        this.scaleMapView();
        this.mapView.emit('zoomed', this.mapView.DEFAULT_ZOOM_EVENT);
        this.centerMapView();
    }
    worldToScreenPoint(worldPoint) {
        return this.mapView.toScreen(worldPoint);
    }
    getTileViewForHexFace(hexFace) {
        for (const tileView of this.tileViews){
            if (tileView.hexFace.sameFace(hexFace)) return tileView;
        }
        return undefined;
    }
    constructor(uiGameManager, shouldHighlightOnlyOnHover){
        this.mapBuilt = false;
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.mapView = this.initializeMapView();
        this.lastCanvasWidth = this.uiGameManager.canvasController.appW;
        this.tileViews = [];
        this.hoverController = new UIGameMapHoverController(this.uiGameManager, shouldHighlightOnlyOnHover);
        new UIGameMapTileCenterHighlightController(this.uiGameManager);
        new UIGameMapTileEdgeHighlightController(this.uiGameManager);
        new UIGameMapTileCornerHighlightController(this.uiGameManager);
    }
}
